import { render, staticRenderFns } from "./SalesTabsManagement.vue?vue&type=template&id=27f0b906&scoped=true"
import script from "./SalesTabsManagement.vue?vue&type=script&lang=ts"
export * from "./SalesTabsManagement.vue?vue&type=script&lang=ts"
import style0 from "./SalesTabsManagement.vue?vue&type=style&index=0&id=27f0b906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0b906",
  null
  
)

export default component.exports